document.addEventListener("DOMContentLoaded", function () {
  function handleMobileFooter() {
    const footerDetails = document.querySelectorAll(
      ".footer-block__details-content"
    );
    const footerHeadings = document.querySelectorAll(".footer-block__heading");

    if (window.innerWidth <= 749) {
      footerDetails.forEach((detail) => {
        detail.style.display = "none";
      });

      footerHeadings.forEach((heading) => {
        heading.removeEventListener("click", toggleAccordion);

        heading.style.cursor = "pointer";
        heading.addEventListener("click", toggleAccordion);
      });
    } else {
      footerDetails.forEach((detail) => {
        detail.style.display = "block";
      });

      footerHeadings.forEach((heading) => {
        heading.style.cursor = "default";
        heading.removeEventListener("click", toggleAccordion);
      });
    }
  }

  function toggleAccordion() {
    const content = this.nextElementSibling;
    if (content.classList.contains("footer-block__details-content")) {
      if (content.style.display === "none" || content.style.display === "") {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    }
  }

  handleMobileFooter();

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleMobileFooter, 250);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var offcanvasMenu = document.querySelector(".offcanvas-menu");

  document.querySelectorAll(".menu-click").forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.stopPropagation(); // Stop propagation to prevent the body click event from triggering
      offcanvasMenu.classList.toggle("open");
      toggleBodyOverflow();
    });
  });

  document.body.addEventListener("swipeleft", function () {
    offcanvasMenu.classList.add("open");
    toggleBodyOverflow();
  });

  document
    .querySelector(".offcanvas-menu")
    .addEventListener("swiperight", function () {
      offcanvasMenu.classList.toggle("open");
      toggleBodyOverflow();
    });

  document.body.addEventListener("click", function (event) {
    const offcanvasMenus = document.querySelectorAll(".offcanvas-menu");

    offcanvasMenus.forEach((offcanvasMenu) => {
      if (
        !offcanvasMenu.contains(event.target) &&
        !event.target.closest(".offcanvas-menu")
      ) {
        if (!offcanvasMenu.classList.contains("open")) {
          return;
        }

        offcanvasMenu.classList.remove("open");
        toggleBodyOverflow();
      }
    });
  });

  function toggleBodyOverflow() {
    document.body.classList.toggle("overflow-hidden");
  }
});
